module.exports = __webpack_public_path__ + "static/media/Stay_home.e74abea8.svg";